module.exports = __webpack_public_path__ + "img/B3.0e4a1cdb.png";